module.exports = __webpack_public_path__ + "static/media/ai.7445e66f.svg";